import React from 'react';
import { Typography } from '@mui/material';

import { getDueDateDisplay } from '../dueDates';

interface Props {
  readonly dueDate: string | null | undefined;
}

/** A compact project deadline label with urgency conveyed through theme colors. */
export function DueDateText({ dueDate }: Props) {
  const display = getDueDateDisplay(dueDate);

  if (!display) {
    return (
      <Typography component="span" variant="body2" color="text.secondary">
        —
      </Typography>
    );
  }

  const color = display.tone === 'overdue' ? 'error.main' : display.tone === 'imminent' ? 'success.main' : undefined;
  const urgencyLabel =
    display.tone === 'overdue'
      ? `${display.label}, overdue`
      : display.tone === 'imminent'
        ? `${display.label}, due soon`
        : undefined;

  return (
    <Typography
      aria-label={urgencyLabel}
      component="span"
      variant="body2"
      color={color}
      sx={{ fontWeight: display.tone === 'default' ? 400 : 500 }}
    >
      {display.label}
    </Typography>
  );
}
